'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AdBanner from '@/components/AdBanner';
import BoardList from '@/components/BoardList';

/**
 * Machinery Hire
 *
 * The body is BoardList, reading entries the FarmTradeDirect team adds in
 * Admin -> Boards. This page previously held a hardcoded array of invented hire categories and machines.
 */
export default function MachineryHireScreen() {
  return (
    <main className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 py-8">
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-extrabold text-foreground">Machinery Hire</h1>
        <p className="text-muted-foreground text-sm mt-2 max-w-2xl leading-relaxed">
          Agricultural machinery for hire &mdash; tractors, telehandlers, combines, sprayers and more. Short and long term. Enquire on anything below and the FarmTradeDirect team will sort the dates and the rate with you.
        </p>
      </div>

      <div className="flex items-start gap-3 bg-blue-50 border border-blue-200 rounded-xl px-5 py-4 mb-6">
        <Icon name="InformationCircleIcon" size={20} className="text-blue-600 shrink-0 mt-0.5" />
        <p className="text-sm text-blue-900">Rates shown are a guide. Delivery, operator and length of hire all affect the final price, so send an enquiry for a firm quote.</p>
      </div>


      <BoardList
        board="machinery-hire"
        emptyTitle="No machinery listed for hire yet"
        emptyMessage="Machines are added as they become available for hire. If there is something specific you need, send us an enquiry and we will look for it."
        enquiryLabel="Enquire about hire"
      />

      <div className="mt-10">
        <AdBanner width={728} height={90} label="728x90 Leaderboard Banner" className="mx-auto rounded-lg" />
      </div>
    </main>
  );
}
